import { Helmet } from "react-helmet";
import StylishBanner from "../components/Reusable Elements/StylishBanner";
import Button from "../components/Reusable Elements/Button";
import PaymentPlans from "../components/Sections/PaymentPlans";

const PaymentPlan = () => {
    return (
        <div>
            <Helmet>
                <title>Payment Plan</title>
            </Helmet>
            <div style={{ paddingTop: "99px" }}>
                <StylishBanner heading={"Payment Plan"} number={2} />
                <div className="flex flex-col items-center justify-center w-screen">
                    <div className="font-poppins text-2xl text-primary-blue pt-9 font-extralight w-[80%] text-center">
                        At Sultana Homes, we offer unbeatable payment plans for
                        residences in Lahore, adopting global practices to make
                        your dream home more accessible.
                    </div>
                    <div className="font-poppins text-2xl text-primary-blue pt-14 font-extralight text-center w-[80%]">
                        Why wait for your future? Start building your ideal home
                        today with our innovative, flexible options.
                    </div>
                </div>
            </div>
            <div className="pt-12 flex justify-center pb-12">
                <Button
                    text={"Contact us"}
                    color={"#ffffff"}
                    location={"/contact"}
                />
            </div>
            <PaymentPlans background={"dark"}/>
        </div>
    );
};

export default PaymentPlan;
